import { render } from "./CitationPopUp.vue?vue&type=template&id=5e5b4dd4"
const script = {}
script.render = render

export default script